import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Tooltip from '../../common/components/dataDisplay/Tooltip'
import Button from '../../common/components/general/Button'

type WizardPreviousButtonProps = {
  disabled?: boolean
  loading?: boolean
  text?: string
  onClick?: React.MouseEventHandler<HTMLElement>
}

const WizardPreviousButton: React.FC<WizardPreviousButtonProps> = (props) => {
  const { t: translate } = useTranslation()

  return (
    <Button
      icon="fa fa-arrow-left"
      size="large"
      htmlType="button"
      type="default"
      className={'t-admin-signup-previous-btn'}
      onClick={props.onClick}
      disabled={props.disabled}
      loading={props.loading}
    >
      {props.text ?? translate('general.previous')}
    </Button>
  )
}

export default WizardPreviousButton
